import PropTypes from 'prop-types';
import { useI18n } from '../../../../context/I18nContext';
import SearchInput from '../../../SearchInput';
// For CSS properties, please check src/components/Page/Conversations/SideBar/Controls.css

const Controls = ({
  searchTerm = '',
  isSearching = false,
  setIsSearching = () => {},
  setSearchTerm = () => {},
  cancelSearch = () => {},
  onMenuToggle = () => {},
}) => {
  const { t } = useI18n();

  return (
    <div className="side-bar-controls">
      {
        !isSearching && <div className="side-bar-menu-toggle" onClick={onMenuToggle}>
          <ion-icon name="menu-outline" />
        </div>
      }
      <div className="side-bar-search-input">
        <SearchInput
          id="sidebar-contacts-search"
          value={searchTerm}
          placeholderValue={t('SearchInput.search')}
          onChange={setSearchTerm}
          onFocus={() => setIsSearching(true)}
          onClearClick={() => setSearchTerm('')}
        />
      </div>
      {
        isSearching && <div
          className="side-bar-cancel-search"
          onClick={cancelSearch}
        >
          { t('cancel') }
        </div>
      }
    </div>
  );
};

Controls.propTypes = {
  searchTerm: PropTypes.string,
  isSearching: PropTypes.bool,
  isCreatingConversation: PropTypes.bool,
  setIsSearching: PropTypes.func,
  setSearchTerm: PropTypes.func,
  cancelSearch: PropTypes.func,
  onMenuToggle: PropTypes.func,
  onCreateConversationClick: PropTypes.func,
};

export default Controls;
